export const boldBorder = '4px solid rgba(255,255,255,0.5)';
export const whiteBoxShadowBorder = '0 0 6px 2px rgb(255 255 255 / 59%);';
export const containerBoxShadow = '0 10px 20px 0 rgb(0 0 0 / 50%)';
